import React, { useMemo, useRef } from 'react';
import { Loader, LoaderSizes } from '@components/Loader/Loader';
import { translate } from '@utils/i18n';
import NoteForm from './components/NoteForm';
import { IndexNamespace, FiltererOptions } from './constants';
import Activity from './components/Activity';
import FilterSection from './components/FilterSection';
import './ActivityFeed.scss';
import useActivities from './hooks/useActivities';
import useInfiniteScroll from './hooks/useInfiniteScroll';
import useVisibilityListener from './hooks/useVisibilityListener';
import useActivityFeedScroll from './hooks/useActivityFeedScroll';
import { ActivityFeedContext } from './hooks/useActivityFeedCtx';
function ActivityFeed({ buildingId, inspectionId, workOrderId, deficiencyId, notesEnabled = true }) {
    const { groupedActivities, isLoading, hasMore, fetchMore } = useActivities({
        buildingId,
        inspectionId,
        workOrderId,
        deficiencyId
    });
    const listContainer = useRef(null);
    useInfiniteScroll(listContainer, fetchMore, hasMore, isLoading);
    const { scrollToBottom, scrollToTop } = useActivityFeedScroll(listContainer);
    const isBuilding = useMemo(() => !(inspectionId || workOrderId || deficiencyId), []);
    // Use the scroll hook for visibility listener
    useVisibilityListener(listContainer, scrollToBottom);
    const contextValue = useMemo(() => ({
        scrollToBottom,
        scrollToTop
    }), [scrollToBottom, scrollToTop]);
    return (React.createElement(ActivityFeedContext.Provider, { value: contextValue },
        React.createElement("div", { className: "workspace__activity activityFeedContainer" },
            React.createElement("div", { className: "activity__major" },
                groupedActivities.length === 0 && (React.createElement("section", { className: "workspace__section" }, isLoading ? (React.createElement("div", { className: "loadingContainer" },
                    React.createElement(Loader, { size: LoaderSizes.large }))) : (React.createElement("article", { className: "section__content" }, translate('no_activities', { namespace: IndexNamespace }))))),
                groupedActivities.length > 0 && (React.createElement("div", { className: "activityListContainer", ref: listContainer },
                    isLoading && React.createElement(Loader, { size: LoaderSizes.large }),
                    groupedActivities.map(({ date, activities }) => (React.createElement("section", { key: date, className: "workspace__section activityGroup" },
                        React.createElement("header", { className: "dateSeparator" },
                            React.createElement("h2", { className: "section__label" }, date),
                            React.createElement("span", null,
                                activities.length,
                                " ",
                                translate('updates', { namespace: IndexNamespace })),
                            React.createElement("hr", { className: "section__split" })),
                        React.createElement("div", { role: "presentation", className: "activity__list" }, activities.map((activity) => (React.createElement(Activity, { activity: activity, isBuilding: isBuilding, key: activity.id }))))))))),
                notesEnabled && (React.createElement(NoteForm, { buildingId: buildingId, workOrderId: workOrderId, inspectionId: inspectionId, deficiencyId: deficiencyId }))),
            React.createElement("div", { className: "activity__minor" },
                React.createElement(FilterSection, { notesEnabled: notesEnabled, availableFilters: isBuilding ? [FiltererOptions.System, FiltererOptions.Notes] : Object.values(FiltererOptions) })))));
}
export default ActivityFeed;
